/**
 * Evita repetir o bootstrap global quando o Template remonta (ex.: Route com
 * `component={() => <Template />}` gera função nova a cada render do App).
 * Reseta no logout para o próximo login carregar dados de novo.
 */
let appBootstrapCompleted = false;

export const runOnceAppBootstrap = (run) => {
  if (appBootstrapCompleted) return;
  appBootstrapCompleted = true;
  run();
};

export const resetAppBootstrapGate = () => {
  appBootstrapCompleted = false;
};
